import React from 'react';
import { SideBarCSS } from '../styles/style';
import { PDF_TEXTS } from '../utils/texts';
import { timeConverter } from 'src/common/config/FunctionHelper';

interface ReportMetadataProps {
  url?: string;
  compareDate: number;
  currentDate: number;
  dateFormat?: string;
}

export const ReportMetadata: React.FC<ReportMetadataProps> = ({
  url,
  compareDate,
  currentDate,
  dateFormat = 'DD/MM/YYYY'
}) => (
  <div style={SideBarCSS.metaDataBar}>
    <span style={SideBarCSS.metaDataUrl}>
      {url?.replace(/^www\./, '')}
    </span>
    <span style={SideBarCSS.metaDataCompare}>
      {compareDate !== 0
        ? `${PDF_TEXTS.preview.canvas.comparedWithFirst} (${timeConverter(
            compareDate,
            dateFormat,
            true,
            false,
            true
          )})`
        : ''}
    </span>
    <span>
      {timeConverter(currentDate, dateFormat)}
    </span>
  </div>
);
